import { Box, ButtonBase } from "@mui/material";
import * as S from "./styles";

const truncateDescription = (text, isTitle) => {
    if (!text) return "";
    const maxLength = isTitle ? 22 : 50;
    if (text.length <= maxLength) return text;
    return `${text.substring(0, maxLength - 3)}...`;
};

export const DesafioCard = ({
    desafio,
    isWizard,
    onClick,
    width = "270px",
    isFullWidth = false,
}) => {
    if (!desafio) return null;

    return (
        <ButtonBase
            onClick={onClick}
            sx={{
                cursor: "pointer",
                width: isFullWidth ? "100%" : width,
                margin: isFullWidth ? 0 : "0 12px 0 0",
            }}
        >
            <S.DesafioItem isWizard={isWizard} isFullWidth={isFullWidth} className="desafioCard">
                <Box
                    sx={{
                        width: "100%",
                        height: "60px",
                        display: "grid",
                        alignContent: "end",
                        justifyContent: "end",
                    }}
                >
                    <S.BoldText isWizard={isWizard}>
                        {desafio?.id && (
                            <><small>Desafio</small><br /></>)}
                        {truncateDescription(desafio.titulo, true)}
                    </S.BoldText>
                </Box>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <S.Subtitle isWizard={isWizard}>{`+${desafio.pontos || 0} pontos`}</S.Subtitle>
                </Box>
            </S.DesafioItem>
        </ButtonBase>
    );
};
